import config from '@/services/config'
import axios from './axios_interceptors'

export default {
  getCampaignInfluencerUserNetworks(page = 1) {
    return axios.get(`${config.urlCore}/api/v4/internal-campaigns/campaign-influencer-user-networks/`, {
      params: { page },
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    })
      .then(response => response.data.response)
      .catch(error => error.response)
  },
  hasInternalCampaigns() {
    return axios.get(`${config.urlCore}/api/v4/internal-campaigns/campaign-influencer-user-networks/has/`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    })
      .then(response => response.data.response)
      .catch(() => ({ has_campaign_influencer_user_network: false }))
  },
  getInfluencerContentInsights(influencer_content_uuid) {
    return axios.get(`${config.urlCore}/api/v4/internal-campaigns/influencer-content/${influencer_content_uuid}/insights/`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    })
      .then(response => response.data.response)
      .catch(error => error.response)
  }
}
